import { createI18n } from 'vue-i18n';

import nl from './nl-NL.json';

export const i18n = createI18n({
  // You must set `false`, to use Composition API
  legacy: false,
  locale: 'nl-NL',
  fallbackLocale: 'nl-NL',
  messages: {
    'nl-NL': nl,
  },
});
